import React, { Fragment, useState } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { H3 } from "../../../AbstractElements";
import { X } from "react-feather";
import CategoryForm from "../Forms/CategoryForm";

const AddCategoryModal = (props) => {
    const [open, setOpen] = useState(props.value);
    const userType = sessionStorage.getItem('userType');

    const onClose = () => {
        setOpen(false);
        props.setOpenModal(false)
    }

    return (
        <Fragment>
            <Modal centered={true} isOpen={open} size='lg'>
                <ModalHeader style={{ display: 'flex' }}>
                    <H3 attrH3={{ className: 'modal-title-color' }}>Credit Rates
                        <X className="x-button" onClick={onClose}/>
                    </H3>
                </ModalHeader>
                <ModalBody>
                    <CategoryForm action={'Add'} cancel={onClose} setAdd={props.setAdd} />
                </ModalBody>
            </Modal>
        </Fragment>
    )
}

export default AddCategoryModal;